import React from 'react';
import ValidityHelper from '../../../Helpers/ValidityHelper';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import ProjectTpJobEditItem from '../../../Domain/ThirdParty/Project/ProjectTpJobEditItem';
import TpJobService from '../../../Services/TpJobService';

class EditProjectTpJobWindowDescription extends React.Component {
  static titleForCreate = '';
  static titleForEdit = 'Edit Third-Party Jobs';
  static itemType = ProjectTpJobEditItem;
  static serviceFunction = (edited) =>
    TpJobService.EditMultiple(
      edited,
      EditProjectTpJobWindowDescription.getSelected(),
      EditProjectTpJobWindowDescription.getAllItemsInTheSearchAreSelected(),
      EditProjectTpJobWindowDescription.getSearchParameters()
    );
  static waitForResponseOnWait = false;

  static getSelected() {}

  static getSearchParameters() {}

  static getAllItemsInTheSearchAreSelected() {}

  static pagesInGeneralEditWizzard = [
    {
      label: 'Uninvoiceable',
      fields: [
        {
          fieldName: 'UninvoiceableEnabled',
          label: 'Modify Uninvoiceable',
          className: 'col-12',
          type: InputTypesEnum.OnOff,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'Uninvoiceable',
          label: 'Uninvoiceable?',
          className: 'col-12',
          type: InputTypesEnum.Checkbox,
          validityChecker: ValidityHelper.AlwaysFlawless,
          hide: (item) => item.UninvoiceableEnabled !== true,
        },
        {
          fieldName: 'PaidOutsideOfSystemEnabled',
          label: 'Modify Paid Outside of System',
          className: 'col-12',
          type: InputTypesEnum.OnOff,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'PaidOutsideOfSystem',
          label: 'Paid Outside of System?',
          className: 'col-12',
          type: InputTypesEnum.Checkbox,
          validityChecker: ValidityHelper.AlwaysFlawless,
          hide: (item) => item.PaidOutsideOfSystemEnabled !== true,
        },
        {
          fieldName: 'AdHocGroupEnabled',
          label: 'Ad-Hoc Invoice Group',
          className: 'col-12',
          type: InputTypesEnum.OnOff,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'AdHocGroup',
          label: 'Ad-Hoc Invoice Group',
          className: 'col-12',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.AlwaysFlawless,
          hide: (item) => item.AdHocGroupEnabled !== true,
        },
      ],
    },
  ];
}

export default EditProjectTpJobWindowDescription;
